module.exports = __webpack_public_path__ + "img/home1.f297a346.jpg";